import { Button, ButtonProps } from "@chakra-ui/react";
import ButtonPopoverSelect from "components/Shared/ButtonPopoverSelect";
import OrderingPlatformSelect, {
  Option,
} from "components/Shared/Select/OrderingPlatformSelect";

type Props = {
  buttonProps?: ButtonProps;
  existingIds?: string[];
  onSelect: (orderingPlatformId: string) => void;
};

export default function AddNewOrderingPlatform({
  buttonProps,
  existingIds,
  onSelect,
}: Props) {
  const { children: buttonChildren = "Add", ...restButtonProps } =
    buttonProps || {};
  return (
    <ButtonPopoverSelect<Option, false>
      renderSelect={(selectProps, { onClose }) => (
        <OrderingPlatformSelect
          {...selectProps}
          excludedIds={existingIds}
          isAddedToBrand
          onChange={(orderingPlatformId) => {
            if (orderingPlatformId) onSelect(orderingPlatformId);
            onClose();
          }}
        />
      )}
    >
      <Button {...restButtonProps}>{buttonChildren}</Button>
    </ButtonPopoverSelect>
  );
}
